import { render, staticRenderFns } from "./LogisticsTracking.vue?vue&type=template&id=30bd262c&scoped=true&"
import script from "./LogisticsTracking.vue?vue&type=script&lang=js&"
export * from "./LogisticsTracking.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsTracking.vue?vue&type=style&index=0&id=30bd262c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bd262c",
  null
  
)

export default component.exports